import { queryOptions } from "@tanstack/react-query";
import { getProgram, searchPrograms } from "api-client";

import {
  type ProgramDetail,
  type ProgramList,
  type ProgramListInput,
  type ProgramsRepository,
} from "./ProgramsRepository";

export function createPersonalLibraryProgramsRepository() {
  const rootKey = ["programs", "personal-library"] as const;
  const repository = {
    listOptions(input: ProgramListInput) {
      return queryOptions<ProgramList>({
        queryKey: [...rootKey, "list", input],
        async queryFn() {
          const response = await searchPrograms({
            query: { ...input, source: "library" },
          });
          return response.data.data;
        },
      });
    },
    detailOptions(programId: string) {
      return queryOptions<ProgramDetail>({
        queryKey: [...rootKey, "detail", programId],
        async queryFn() {
          const response = await getProgram({ path: { id: programId } });
          return response.data.data;
        },
      });
    },
  };

  return repository satisfies ProgramsRepository;
}
